/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

const PAMediaRemovalHeader = () => {
	const { t } = useTranslation();
	return (
		<div className="bg-white px-8 py-3 shrink-0 border-b border-slate-100 shadow-sm">
			<div className="flex justify-between items-center">
				<div className="flex items-center gap-6">
					<div className="w-12 h-12 bg-orange-50 rounded-xl flex items-center justify-center">
						<span className="material-symbols-outlined text-[#FF7043] text-3xl">
							logout
						</span>
					</div>
					<div>
						<h2 className="text-2xl font-black text-[#2D3E50] tracking-tight">
							{t('postAutoclaveProcess.mediaRemoval.title')}
						</h2>
						<p className="text-xs font-bold text-slate-400 uppercase tracking-widest mt-1">
							{t('postAutoclaveProcess.mediaRemoval.subText')}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PAMediaRemovalHeader;
